import styled, { css } from 'styled-components';

interface ContainerProps {
  type?: 'success' | 'error' | 'info';
}

const toastTypeVariations = {
  info: css`
    color: var(--info);

    div > div:first-child {
      background: var(--info-transparent);
    }
  `,
  success: css`
    color: var(--success);

    div > div:first-child {
      background: var(--success-transparent);
    }
  `,
  error: css`
    color: var(--danger);

    div > div:first-child {
      background: var(--danger-transparent);
    }
  `,
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 350px;
  height: auto;
  background: var(--white);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
  pointer-events: all;
  cursor: pointer;
  animation: push 0.4s ease-in-out;
  border: 1px solid var(--gray-e);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);

  @keyframes push {
    from {
      transform: translateX(50px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  ${props => toastTypeVariations[props.type || 'info']}

  > div {
    display: flex;
    align-items: center;
  }

  div > div:first-child {
    min-width: 50px;
    height: 50px;
    border-radius: 25px;
    margin-right: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  > div strong {
    font-size: 16px;
    color: var(--black-3);
  }

  div > p {
    font-size: 14px;
    color: var(--black-7);
  }

  @media (max-width: 800px) {
    width: 100%;
  }
`;
